 import { Injectable } from '@angular/core';
 import {environment} from '../../../../environments/environment';
 import {Headers, Http, RequestOptions} from '@angular/http';
 import {CookieService} from 'ngx-cookie';
 declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class PatientService {
  readonly baseURL = DDP_ENV.campaignUrl;

  constructor(private _http: Http, private cookieService: CookieService) {}

  getAllPatients(page, status, size, regEx) {
    console.log('Inside get patients');

      return this._http.get(this.baseURL + '/app/patient' + '?page=' + page + '&status=' + status + '&size=' + size + '&regexPattern=' + regEx, this.buildHeaders());


      // tslint:disable-next-line:max-line-length
   /* if(regEx===''){
        return this._http.get(this.baseURL + '/patients/client/' + localStorage.getItem('clientId') + '?page=' + page + '&status=' + status + '&size=' + size, this.buildHeaders());
    }else{
        return this._http.get(this.baseURL + '/patients/client/' + localStorage.getItem('clientId') + '?page=' + page + '&status=' + status + '&size=' + size + '&regexPattern=' + regEx, this.buildHeaders());
    }*/

  }

  getPatient(mrn) {
    console.log('Inside get patient details for mrn : ' + mrn);
    return this._http.get(this.baseURL + '/patients/' + mrn, this.buildHeaders());
  }

  addUpdatePatient(patientData) {
    if (patientData.id === '') {
      return this._http.post(this.baseURL + '/device/user/register/patient', patientData, this.buildHeaders());
    } else {
      return this._http.put(this.baseURL + '/patient/' + patientData.id, patientData, this.buildHeaders());
    }
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

}
